// export default CreateInvoicePage;
import CreateCreditNoteForm from "@components/CreateCreditNoteForm/CreateCreditNoteForm";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
import { useGetClientsQuery } from "store/client/clientApi";
import { useSelector } from "react-redux";
import { useGetInvoicesQuery } from "store/invoice/invoiceApi";
import { CreateModalContext } from "layouts/appLayout/layout";

const CreateAvoirPage = () => {
  const { t } = useTranslation();
  const currentUser = useSelector((state) => state.auth.user);

  const companyId = currentUser?.companyId?._id;
  const { data: clients = { data: [] } } = useGetClientsQuery(companyId);

  return (
    <div className="invoice-layout d-flex p-5">
      <div className="invoice-create-container">
        <div className="invoice-create-header">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <h1 className="p-2">{t("avoir.new_invoice")}</h1>
            <span
              style={{
                background: "#f5f5f5",
                color: "#555",
                borderRadius: "16px",
                padding: "0.3rem 1rem",
                fontSize: "1rem",
                fontWeight: 500,
                border: "1px solid #e0e0e0",
                marginLeft: "auto",
              }}>
              <b>{t("avoir.draft")}</b>
            </span>
          </div>
        </div>

        <CreateCreditNoteForm companyId={companyId} />
      </div>
    </div>
  );
};

export default CreateAvoirPage;
